export const ConfigurationIdentifiers = {
  LODGING_DATED_PDP_CAROUSEL_FEATURED_HEADER_CHECK: 'lodging_dated_pdp:lodging_featured_header_check',
  LODGING_DATED_PDP_CAROUSEL_NO_FEATURED_HEADER_CHECK: 'lodging_dated_pdp:lodging_no_featured_header_check'
};